import { render } from "./FilterSidebarInServiceSection.vue?vue&type=template&id=2034b55d&scoped=true"
import script from "./FilterSidebarInServiceSection.vue?vue&type=script&lang=js"
export * from "./FilterSidebarInServiceSection.vue?vue&type=script&lang=js"

import "./FilterSidebarInServiceSection.vue?vue&type=style&index=0&id=2034b55d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2034b55d"]])

export default __exports__